import Vue from 'vue';
import {Model} from '@vuex-orm/core';
import store from '$src/store';

export default class Group extends Model {

    static entity = 'group';
    static primaryKey = 'id_group';

    static fields() {
        return {
            id_group: this.number(null),
            id_image: this.attr(null),
            title: this.string(''),
            description: this.string(''),
            public_wiki: this.boolean(false),
            wiki_page_count: this.attr(0),
            public_registration: this.boolean(false),
            status: this.number(0),
            _entityAuth: this.attr({}),
            user_count: this.attr(null),
            invited_at: this.attr(null),
        };
    }

    get link() {
        return {route: 'community_group', params: {id_group: this.id_group}};
    }

    get linkEdit() {
        return {route: 'community_group_edit', params: {id_group: this.id_group}};
    }

    get image() {
        return Vue.$img(this.id_image, '/img/group.jpg');
    }

    get roles() {
        if (this.role_ids.length > 0) {
            return this.role_ids.split(',').map(id_role => store.getters['auth/getRoleById'](id_role));
        }
        return [];
    }

    get rolesString() {
        return this.roles.map(role => role.label).join(', ');
    }

    hasRole(name) {
        return !!this.roles.find(role => role.name === name);
    }

}